<template>
    <div class="calendar-box" :class="{ 'mobile': isMobile }">
        <!-- 移动端使用vant组件 -->
        <div v-if="isMobile" class="mobile-calendar">
            <!-- 移动端日历选择器 -->
            <van-calendar
                v-model="showMobileCalendar"
                :min-date="new Date(currentYear - 1, currentMonth - 1, 1)"
                :max-date="new Date(currentYear + 1, currentMonth - 1, 1)"
                @confirm="onMobileCalendarConfirm"
                @change="onMobileCalendarChange"
            >
                <template #title>
                    <div class="mobile-calendar-header">
                        <span>{{currentYear}}年{{currentMonth}}月</span>
                        <van-button size="small" type="primary" @click="showMobileCalendar = false">关闭</van-button>
                    </div>
                </template>
            </van-calendar>
            
            <!-- 移动端当前日期信息 -->
            <div class="mobile-current-info">
                <div class="mobile-date">{{currentYear}}年{{currentMonth}}月</div>
                <div class="mobile-lunar">{{currentLunarYear}}年[{{currentLunarZodiac}}]</div>
                <van-button type="primary" @click="showMobileCalendar = true">选择日期</van-button>
            </div>
            
            <!-- 移动端日历显示 -->
            <div class="calendar-day mobile-calendar-day">
                <div class="calendar-day-list" v-for="(value,key) in week" :key="key">
                    <div class="calendar-day-list-week-small">
                        <div v-if="value.num === 0 || value.num === 6" class="rest">{{value.small}}</div>
                        <div v-else>{{value.small}}</div>
                    </div>
                </div>
                <div class="calendar-day-list" v-for="(value,key) in date" :key="key">
                    <!-- 电脑端显示特殊日子标记图标 -->
                    <div class="festival-icon" v-if="!isMobile && value.festival.length>0">
                        <img src="https://cdn.cxc-group.com/admin/festival-icon.png"/>
                    </div>
                    <!-- 手机端节日图标放在日期底层 -->
                    <div class="mobile-festival-bg" v-if="isMobile && value.festival.length>0">
                        <div class="mobile-festival-icon" v-for="(festival, index) in value.festival" :key="index" :style="{ transform: `translate(${(index - (value.festival.length - 1) / 2) * 20}px, -50%)` }">
                            <img v-if="festival.type === 0" src="https://cdn.cxc-group.com/manage/normal-festival-icon.png"/>
                            <img v-else-if="festival.type === 1" src="https://cdn.cxc-group.com/manage/fo-festival-icon.png"/>
                            <img v-else-if="festival.type === 2" src="https://cdn.cxc-group.com/manage/dao-festival-icon.png"/>
                        </div>
                    </div>
                    <div class="calendar-day-list-info" :class="{
                        'not-current' :parseInt(currentMonth)!==parseInt(value.month),
                        'selected' : selectedDate === (value.year+'-'+value.month+'-'+value.day)
                    }" @click="lookDetail(key)">
                        <div class="calendar-day-list-info-date">
                            <span v-if="(value.year+'-'+value.month+'-'+value.day) === today" class="today">
                                {{value.day}}
                            </span>
                            <span v-else-if="parseInt(value.week) === 0 || parseInt(value.week) === 6" class="rest">
                                {{value.day}}
                            </span>
                            <span v-else>
                                {{value.day}}
                            </span>
                        </div>
                        <div class="calendar-day-list-info-lunar">
                            <span>{{value.lunar[2]}}</span>
                        </div>
                        <!-- 电脑端显示节日名称，手机端不显示 -->
                        <div class="calendar-day-list-info-festival" v-if="!isMobile && value.festival.length>0">
                            <div class="calendar-day-list-info-festival-list" v-for="(v,k) in value.festival" :key="k">
                                <van-tag
                                    class="calendar-day-list-info-festival-list-tag normal-icon"
                                    size="small"
                                    v-if="parseInt(v.type)===0"
                                >
                                    <img class="calendar-day-list-info-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/normal-festival-icon.png"/>
                                    {{v.name}}
                                </van-tag>
                                <van-tag
                                    class="calendar-day-list-info-festival-list-tag fo-icon"
                                    size="small"
                                    v-if="parseInt(v.type)===1"
                                >
                                    <img class="calendar-day-list-info-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/fo-festival-icon.png"/>
                                    {{v.name}}
                                </van-tag>
                                <van-tag
                                    class="calendar-day-list-info-festival-list-tag dao-icon"
                                    size="small"
                                    v-if="parseInt(v.type)===2"
                                >
                                    <img class="calendar-day-list-info-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/dao-festival-icon.png"/>
                                    {{v.name}}
                                </van-tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 移动端节日详情弹窗 -->
            <van-popup v-model="lookDrawer" position="right" :style="{ width: '100%', height: '100%' }">
                <div class="calendar-look-title mobile-look-title">
                    <div>
                        <div class="calendar-look-title-date">{{look.day}}</div>
                        <div class="calendar-look-title-lunar">
                            <div class="calendar-look-title-lunar-text">{{look.lunar[3]}}{{look.lunar[6]}}年{{look.lunar[1]}}{{look.lunar[2]}}</div>
                        </div>
                    </div>
                </div>
                <div class="calendar-detail">
                    <div class="calendar-detail-empty" v-if="look.festival.length === 0">
                        <van-empty description="暂无节日" />
                    </div>
                    <div class="calendar-detail-festival" v-else>
                        <div class="calendar-detail-festival-list" v-for="(value,key) in look.festival" :key="key">
                            <div class="calendar-detail-festival-list-left">
                                <img v-if="parseInt(value.type) === 0" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/normal-festival-icon.png"/>
                                <img v-if="parseInt(value.type) === 1" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/fo-festival-icon.png"/>
                                <img v-if="parseInt(value.type) === 2" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/dao-festival-icon.png"/>
                            </div>
                            <div class="calendar-detail-festival-list-content">{{value.name}}</div>
                            <div class="calendar-detail-festival-list-right">
                                <i class="el-icon-reading iconfont"></i>
                                <i class="el-icon-delete iconfont" @click="deleteFestival(value.id)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calendar-festival-add" @click="addFestivalHandler">
                    <i class="el-icon-plus"></i> 添加节日
                </div>
            </van-popup>
            
            <!-- 移动端添加节日弹窗 -->
            <van-popup v-model="addFestival" position="center" :style="{ width: '90%', 'max-width': '500px' }">
                <div class="add-festival-form mobile-add-form">
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">日期</div>
                        <div class="add-festival-form-input">
                            <div class="form-span">{{form.month}}-{{form.day}}</div>
                            <van-radio-group v-model="form.is_lunar" @change="addFestivalChangeLunar">
                                <van-radio name="0">阳历</van-radio>
                                <van-radio name="1">阴历</van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">名称</div>
                        <div class="add-festival-form-input">
                            <van-field v-model="form.name" placeholder="请输入节日名称" />
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">类型</div>
                        <div class="add-festival-form-input">
                            <van-select v-model="form.type" placeholder="请选择类型">
                                <van-option
                                    v-for="(value,key) in typeList"
                                    :key="key"
                                    :label="value.name"
                                    :value="value.type"
                                >
                                    <div style="display: flex; align-items: center;">
                                        <img style="width: 20px; height: 20px; margin-right: 10px;" :src="value.image" />
                                        <span>{{value.name}}</span>
                                    </div>
                                </van-option>
                            </van-select>
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">详情</div>
                        <div class="add-festival-form-input">
                            <van-field
                                v-model="form.info"
                                type="textarea"
                                rows="3"
                                placeholder="请输入节日介绍"
                            />
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label"></div>
                        <div class="add-festival-form-input" style="justify-content: flex-end;">
                            <van-button type="primary" @click="addFestivalSubmit">确认添加</van-button>
                            <van-button @click="cancelFestival">取消</van-button>
                        </div>
                    </div>
                </div>
            </van-popup>
        </div>
        
        <!-- 电脑端使用element-ui组件 -->
        <div v-else class="pc-calendar">
            <div class="calendar-info" v-if="size==='big'">
                <div class="calendar-month">{{currentMonth}}</div>
                <div class="calendar-year">{{currentYear}}</div>
                <div class="calendar-lunar">{{currentLunarYear}}年[{{currentLunarZodiac}}]</div>
            </div>
            <div class="calendar-content">
                <div class="calendar-control">
                    <div v-if="size!=='big'" class="calendar-date">
                        <div class="calendar-control-today">
                            <span class="calendar-month">{{currentYear}}.{{currentMonth}}</span>
                            <span class="calendar-lunar">
                                {{currentLunarYear}}年[{{currentLunarZodiac}}] {{currentLunarMonth}} {{currentLunarDay}}
                            </span>
                        </div>
                        <el-button size="mini" class="calendar-go-info" type="primary" @click="goCalendar">前往日历</el-button>
                    </div>
                    <el-date-picker v-else
                        v-model="searchDate"
                        type="month"
                        placeholder="请搜索月份"
                        align="center"
                        :clearable="true"
                        format="yyyy年MM月"
                        @change="changeCalendar"
                    >
                    </el-date-picker>
                </div>
                <div class="calendar-day">
                    <div class="calendar-day-list" v-for="(value,key) in week" :key="key">
                        <div class="calendar-day-list-week" v-if="size==='big'">
                            <div v-if="value.num === 0 || value.num === 6" class="rest">{{value.name}}<span class="yao">/ {{value.yao}}</span></div>
                            <div v-else>{{value.name}}<span class="yao">/ {{value.yao}}</span></div>
                        </div>
                        <div class="calendar-day-list-week-small" v-else>
                            <div v-if="value.num === 0 || value.num === 6" class="rest">{{value.small}}</div>
                            <div v-else>{{value.small}}</div>
                        </div>
                    </div>
                    <div class="calendar-day-list" v-for="(value,key) in date" :key="key">
                        <div class="festival-icon" v-if="size!=='big' && value.festival.length>0">
                            <img src="https://cdn.cxc-group.com/admin/festival-icon.png"/>
                        </div>
                        <div class="calendar-day-list-info" :class="{'not-current' :parseInt(currentMonth)!==parseInt(value.month)}" @click="lookDetail(key)">
                            <div class="calendar-day-list-info-date">
                                <span v-if="(value.year+'-'+value.month+'-'+value.day) === today" class="today">
                                    {{value.day}}
                                </span>
                                <span v-else-if="parseInt(value.week) === 0 || parseInt(value.week) === 6" class="rest">
                                {{value.day}}
                                </span>
                                <span v-else>
                                    {{value.day}}
                                </span>
                            </div>
                            <div class="calendar-day-list-info-lunar">
                                <span v-if="size!=='mini'">
                                    {{value.lunar[1]}} {{value.lunar[2]}}
                                </span>
                                <span v-else>{{value.lunar[2]}}</span>
                            </div>
                            <div class="calendar-day-list-info-festival" v-if="size!=='mini'">
                                <div class="calendar-day-list-info-festival-list" v-for="(v,k) in value.festival" :key="k">
                                    <el-tag
                                        class="calendar-day-list-info-festival-list-tag normal-icon"
                                        effect="plain"
                                        size="mini"
                                        v-if="parseInt(v.type)===0"
                                    >
                                        <el-image class="calendar-day-list-info-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/normal-festival-icon.png"></el-image>
                                        {{v.name}}
                                    </el-tag>
                                    <el-tag
                                        class="calendar-day-list-info-festival-list-tag fo-icon"
                                        effect="plain"
                                        size="mini"
                                        v-if="parseInt(v.type)===1"
                                    >
                                        <el-image class="calendar-day-list-info-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/fo-festival-icon.png"></el-image>
                                        {{v.name}}
                                    </el-tag>
                                    <el-tag
                                        class="calendar-day-list-info-festival-list-tag dao-icon"
                                        effect="plain"
                                        size="mini"
                                        v-if="parseInt(v.type)===2"
                                    >
                                        <el-image class="calendar-day-list-info-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/dao-festival-icon.png"></el-image>
                                        {{v.name}}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calendar-festival" v-if="size!=='big'">
                    <div class="calendar-detail-empty" style="font-size:12px;text-align:center;color:rgba(0,0,0,0.2)" v-if="festival.length === 0">
                        暂无节日
                    </div>
                    <div class="calendar-detail-festival" v-else>
                        <div class="calendar-detail-festival-list" v-for="(value,key) in festival" :key="key">
                            <div class="calendar-detail-festival-list-left">
                                <el-image v-if="parseInt(value.type) === 0" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/normal-festival-icon.png"></el-image>
                                <el-image v-if="parseInt(value.type) === 1" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/fo-festival-icon.png"></el-image>
                                <el-image v-if="parseInt(value.type) === 2" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/dao-festival-icon.png"></el-image>
                            </div>
                            <div class="calendar-detail-festival-list-content">{{value.name}}</div>
                            <div class="calendar-detail-festival-list-right">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <el-drawer
                :visible.sync="lookDrawer"
                :with-header="false"
                size="30%"
            >
                <div class="calendar-look-title">
                    <div>
                        <div class="calendar-look-title-date">{{look.day}}</div>
                        <div class="calendar-look-title-lunar">
                            <div class="calendar-look-title-lunar-text">{{look.lunar[3]}}{{look.lunar[6]}}年{{look.lunar[1]}}{{look.lunar[2]}}</div>
                        </div>
                    </div>
                </div>
                <div class="calendar-detail">
                    <div class="calendar-detail-empty" v-if="look.festival.length === 0">
                        <el-empty :image-size="200" description="暂无节日"></el-empty>
                    </div>
                    <div class="calendar-detail-festival" v-else>
                        <div class="calendar-detail-festival-list" v-for="(value,key) in look.festival" :key="key">
                            <div class="calendar-detail-festival-list-left">
                                <el-image v-if="parseInt(value.type) === 0" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/normal-festival-icon.png"></el-image>
                                <el-image v-if="parseInt(value.type) === 1" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/fo-festival-icon.png"></el-image>
                                <el-image v-if="parseInt(value.type) === 2" class="calendar-detail-festival-list-icon" fit="contain" src="https://cdn.cxc-group.com/manage/dao-festival-icon.png"></el-image>
                            </div>
                            <div class="calendar-detail-festival-list-content">{{value.name}}</div>
                            <div class="calendar-detail-festival-list-right">
                                <i class="el-icon-reading iconfont"></i>
                                <i class="el-icon-delete iconfont" @click="deleteFestival(value.id)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calendar-festival-add" @click="addFestivalHandler">
                    <i class="el-icon-plus"></i> 添加节日
                </div>
            </el-drawer>

            <el-dialog
                width="40%"
                title="添加节日"
                :visible.sync="addFestival"
                append-to-body
            >
                <div class="add-festival-form">
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">日期</div>
                        <div class="add-festival-form-input">
                            <div class="form-span">{{form.month}}-{{form.day}}</div>
                            <el-radio-group v-model="form.is_lunar" size="small" @change="addFestivalChangeLunar">
                                <el-radio-button :label="0">阳历</el-radio-button>
                                <el-radio-button :label="1">阴历</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">名称</div>
                        <div class="add-festival-form-input">
                            <el-input v-model="form.name" placeholder="请输入节日名称"></el-input>
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">类型</div>
                        <div class="add-festival-form-input">
                            <el-select v-model="form.type" placeholder="请选择类型">
                            <el-option
                                v-for="(value,key) in typeList"
                                :key="key"
                                :label="value.name"
                                :value="value.type">
                                <div class="form-select-list" style="width:100;display:inline-flex;align-items:center;">
                                    <el-image style="width:20px;height: 20px;" fit="contain" :src="value.image"></el-image>
                                    <span style="margin-left: 10px;">{{value.name}}</span>
                                </div>
                            </el-option>
                        </el-select>
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label">详情</div>
                        <div class="add-festival-form-input">
                            <el-input type="textarea":rows="3" v-model="form.info" placeholder="请输入节日介绍"></el-input>
                        </div>
                    </div>
                    <div class="add-festival-form-list">
                        <div class="add-festival-form-label"></div>
                        <div class="add-festival-form-input">
                            <el-button type="primary" @click="addFestivalSubmit">确认添加</el-button>
                            <el-button @click="cancelFestival">取消添加</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {calendar} from "@/api/public.js"
import {addFestival,deleteFestival} from "@/api/temple.js"
export default {
    props:{
        size:{
            default: "big"
        }
    },
    data() {
        return {
            isMobile: false,
            showMobileCalendar: false,
            today:"",
            searchDate:"",
            currentYear:'',
            currentMonth:'',
            currentLunarYear:'',
            currentLunarMonth:'',
            currentLunarDay:'',
            currentLunarZodiac:'',
            week:[
                {'name':'星期日','yao':'日曜日','num':0,'small':'日'},
                {'name':'星期一','yao':'月曜日','num':1,'small':'一'},
                {'name':'星期二','yao':'火曜日','num':2,'small':'二'},
                {'name':'星期三','yao':'水曜日','num':3,'small':'三'},
                {'name':'星期四','yao':'木曜日','num':4,'small':'四'},
                {'name':'星期五','yao':'金曜日','num':5,'small':'五'},
                {'name':'星期六','yao':'土曜日','num':6,'small':'六'},
            ],
            typeList:[
                {'type':0,'name':'法定节日','image':"https://cdn.cxc-group.com/manage/normal-festival-icon.png"},
                {'type':1,'name':'佛门节日','image':"https://cdn.cxc-group.com/manage/fo-festival-icon.png"},
                {'type':2,'name':'道门节日','image':"https://cdn.cxc-group.com/manage/dao-festival-icon.png"},
            ],
            date: [],
            lookDrawer:false,
            look:{
                day:'',
                lunar:[],
                festival:[],
            },
            festival:[],
            addFestival:false,
            selectedDate: '',
            form:{
                month:'',
                day:'',
                name:'',
                is_lunar:0,
                type:0,
                info:'',
            },
            params:{
                day:''
            }
        };
    },

    mounted(){
        // 检测设备类型
        this.checkDeviceType();
        // 监听窗口大小变化
        window.addEventListener('resize', this.checkDeviceType);
        
        var currentDate = new Date();
        this.currentYear = currentDate.getFullYear();
        let year = this.currentYear;
        var month = currentDate.getMonth() + 1;
        if (month >= 1 && month <= 9) month = '0' + month
        var day = currentDate.getDate();
        if (day >= 1 && day <= 9) day = '0' + day
        this.today = year +'-'+month +'-' + day
        this.currentMonth = month;

        this.getCalendar()
    },
    
    beforeDestroy() {
        // 移除事件监听
        window.removeEventListener('resize', this.checkDeviceType);
    },
    
    methods: {
        // 检测设备类型
        checkDeviceType() {
            this.isMobile = window.innerWidth < 768;
        },
        
        // 移动端日历确认事件
        onMobileCalendarConfirm(date) {
            this.showMobileCalendar = false;
            // 处理日期选择逻辑
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.currentYear = year;
            this.currentMonth = month < 10 ? '0' + month : month;
            this.params.day = `${year}-${this.currentMonth}`;
            this.getCalendar();
        },
        
        // 移动端日历月份变化事件
        onMobileCalendarChange(date) {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.currentYear = year;
            this.currentMonth = month < 10 ? '0' + month : month;
            this.params.day = `${year}-${this.currentMonth}`;
            this.getCalendar();
        },
        
        goCalendar(){
            this.$router.push({
                name:'calendar'
            })
        },
        getCalendar() {
            calendar(this.params).then(res=>{
                if(res.code === 200){
                    this.date = res.data
                    res.data.forEach((value,key)=>{
                        if(this.currentLunarYear==='' && parseInt(value.month) === parseInt(this.currentMonth)){
                            this.currentLunarYear = value.lunar[3]
                            this.currentLunarMonth = value.lunar[1]
                            this.currentLunarDay = value.lunar[2]
                            this.currentLunarZodiac = value.lunar[6]
                        }
                        if(`${value.year}-${value.month}-${value.day}` === this.today){
                            this.festival = value.festival
                        }
                    })
                }
            })
        },
        changeCalendar(){
            if(this.searchDate===null){
                var currentDate = new Date();
                this.currentYear = currentDate.getFullYear();
                var month = currentDate.getMonth() + 1;
                if (month >= 1 && month <= 9) month = '0' + month
                this.currentMonth = month
                this.params.day = ''
                this.currentLunarYear=''
            }else{
                this.currentYear = this.searchDate.getFullYear();
                var month = this.searchDate.getMonth() + 1;
                if (month >= 1 && month <= 9) month = '0' + month
                this.currentMonth = month;
                console.log(this.currentMonth)

                this.params.day = this.currentYear+'-'+month
                this.currentLunarYear=''
            }
            this.getCalendar()
        },
        lookDetail(e){
            this.lookDrawer = true;
            const dateStr = this.date[e].year+'-'+this.date[e].month+'-'+this.date[e].day;
            this.selectedDate = dateStr;
            this.look.day = this.date[e].year+'.'+this.date[e].month+'.'+this.date[e].day
            this.look.lunar = this.date[e].lunar
            this.look.festival = this.date[e].festival
            console.log(this.look)
            this.$forceUpdate()
        },
        addFestivalHandler(){
            this.addFestival = true
            let day = this.look.day.split(".")
            this.form.month = day[1]
            this.form.day = day[2]
        },
        addFestivalChangeLunar(e){
            if(e){
                console.log(this.look.lunar)
                
                this.form.month = this.look.lunar[4] < 10 ? '0'+this.look.lunar[4] : this.look.lunar[4]
                this.form.day = this.look.lunar[5] < 10 ? '0'+this.look.lunar[5] : this.look.lunar[5]
            }else{
                let day = this.look.day.split(".")
                this.form.month = day[1]
                this.form.day = day[2]
            }
        },
        addFestivalSubmit(){
            addFestival(this.form).then(res=>{
                if(res.code === 200){
                    this.getCalendar()
                    this.addFestival = false
                    this.lookDrawer = false
                    this.form = {
                        month:'',
                        day:'',
                        name:'',
                        is_lunar:0,
                        type:0,
                        info:'',
                    }
                }
            })
        },
        cancelFestival(){
            this.addFestival = false
            this.form = {
                month:'',
                day:'',
                name:'',
                is_lunar:0,
                type:0,
                info:'',
            }
        },
        deleteFestival(id){
            deleteFestival(id).then(res=>{
                if(res.code === 200){
                    this.lookDrawer = false
                    this.getCalendar()
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
    @import "@/static/default";
    .calendar-box{
        width:100%;
        display:inline-flex;
        justify-content:space-between;
        
        // 移动端样式
        &.mobile {
            flex-direction: column;
            padding: 10px;
            box-sizing: border-box;
            
            .mobile-calendar {
                width: 100%;
                display: flex;
                flex-direction: column;
                
                .van-calendar {
                    margin-bottom: 15px;
                }
            }
            
            .calendar-info {
                width: 100%;
                text-align: center;
                margin-right: 0;
                padding: 10px 0;
                
                .calendar-month {
                    font-size: 60px;
                }
                
                .calendar-year {
                    font-size: 24px;
                }
                
                .calendar-lunar {
                    font-size: 16px;
                }
            }
            
            .calendar-content {
                width: 100%;
                
                .calendar-control {
                    margin-bottom: 15px;
                    
                    .calendar-date {
                        flex-direction: column;
                        align-items: center;
                        gap: 10px;
                        
                        .calendar-control-today {
                            text-align: center;
                            
                            .calendar-month {
                                font-size: 18px;
                            }
                            
                            .calendar-lunar {
                                font-size: 12px;
                                margin-left: 0;
                            }
                        }
                    }
                }
                
                .calendar-day {
                    .calendar-day-list {
                        width: 14.28%;
                        margin-bottom: 10px;
                        
                        &-info {
                            padding: 5px;
                            
                            &-date {
                                font-size: 18px;
                                text-align: center;
                            }
                            
                            &-lunar {
                                font-size: 12px;
                                text-align: center;
                            }
                            
                            &-festival {
                                &-list {
                                    justify-content: center;
                                    margin-bottom: 3px;
                                    
                                    &-tag {
                                        font-size: 10px;
                                        
                                        &-icon {
                                            width: 15px;
                                            height: 15px;
                                            margin-right: 3px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            
            .calendar-look-title {
                height: 150px;
                
                &-date {
                    font-size: 36px;
                }
                
                &-lunar {
                    width: 200px;
                    
                    &-text {
                        font-size: 14px;
                    }
                }
            }
            
            .calendar-detail-festival {
                padding: 10px;
                
                &-list {
                    padding: 8px 15px;
                    margin-bottom: 8px;
                    
                    &-left {
                        width: 40px;
                        height: 40px;
                        margin-right: 8px;
                        
                        img {
                            width: 30px;
                            height: 30px;
                        }
                    }
                    
                    &-content {
                        font-size: 14px;
                    }
                }
            }
            
            .add-festival-form {
                &-list {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 8px;
                    margin-bottom: 15px;
                }
                
                &-label {
                    width: 100%;
                    margin-bottom: 5px;
                }
                
                &-input {
                    width: 100%;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 10px;
                    
                    .form-span {
                        margin-right: 0;
                    }
                }
            }
        }
        
        // 电脑端样式
        &:not(.mobile) {
            .calendar-info{
                width:200px;
                flex-shrink:0;
                text-align:right;
                box-sizing:border-box;
                padding: 20px;
                margin-right: 20px;

                .calendar-month{
                    width:100%;
                    font-size:150px;
                    color:rgba(255, 193, 75, 1);
                }
                .calendar-year{
                    width:100%;
                    font-size:48px;
                }
                .calendar-lunar{
                    color:rgba(0,0,0, 0.2);
                    font-weight:bold;
                    font-size:21px;
                    width:100%;
                }
            }
            .calendar-content{
                width:100%;
                flex-shrink:1;
                .calendar-control{
                    width:100%;
                    display:inline-flex;
                    justify-content:center;
                    margin-bottom: 30px;
                    .calendar-date{
                        width:100%;
                        display:inline-flex;
                        justify-content:space-between;
                        .calendar-control-today{
                            .calendar-month{
                                color:rgba(255, 193, 75, 1);
                                font-size: 20px;
                                font-weight:bold;
                            }
                            .calendar-lunar{
                                color:rgba(0,0,0,0.45);
                                font-size: 14px;
                                margin-left: 10px;
                            }
                        }
                    }
                    /deep/ .el-input__inner{
                        border:none;
                        text-align:center;
                        border-radius:0;
                        box-sizing:border-box;
                        padding: 30px;
                        font-size: 20px;
                        border-bottom:2px solid rgba(255, 193, 75, 1);
                    }
                    .el-input__inner:hover{
                        border-bottom:2px solid rgba(255, 193, 75, 1);
                    }
                }
                .calendar-day{
                    width:100%;
                    display:flex;
                    flex-wrap:wrap;
                    justify-content:space-around;
                    &-list{
                        width:14.28%;
                        margin-bottom: 20px;
                        position:relative;
                        .festival-icon{
                            position:absolute;
                            right:0;
                            top:0;
                            img{
                                width:15px;
                                height: 15px;
                            }
                        }
                        &-week{
                            width:100%;
                            font-size:20px;
                            font-weight:bold;
                            text-align:right;
                            .yao{
                                font-weight:400;
                                font-size: 14px;
                                color:rgba(0,0,0, 0.4);
                                margin-left: 10px;
                            }
                        }
                        &-week-small{
                            width:100%;
                            font-size:16px;
                            font-weight:bold;
                            text-align:center;
                            
                        }
                        &-info:hover{
                            .calendar-day-list-info-date{
                                color:rgba(195, 39, 43,.8) !important;
                                .rest{
                                    color:rgba(195, 39, 43,.8) !important;
                                }
                            }
                        }
                        &-info{
                            width:100%;
                            box-sizing:border-box;
                            padding: 10px;

                            &-date{
                                width:100%;
                                text-align:right;
                                font-size: 24px;
                                font-weight:bold;
                                cursor:default;
                            }
                            &-lunar{
                                width:100%;
                                text-align:right;
                                font-size: 14px;
                                margin-top:5px;
                                cursor:default;
                            }
                            &-festival{
                                width:100%;
                                margin-top: 5px;
                                cursor:default;
                                &-list{
                                    width:100%;
                                    display:inline-flex;
                                    align-items:center;
                                    justify-content:flex-end;
                                    margin-bottom: 5px;

                                    &-tag{
                                        display:inline-flex;
                                        align-items:center;
                                        font-weight:bold;
                                    }
                                    &-icon{
                                        width:20px;
                                        height: 20px;
                                        margin-right:5px;
                                    }
                                    &-name{
                                        font-size:14px;
                                    }
                                }
                            }
                        }
                        .rest{
                            color:rgba(255, 193, 75, 1);
                        }
                        .today{
                            color:#c3272b;
                        }
                    }
                    // 已选择日期样式
                    &.selected {
                        .calendar-day-list-info-date {
                            background-color: rgba(255, 193, 75, 0.2);
                            border-radius: 12px;
                            color: rgba(255, 193, 75, 1);
                            
                            .today {
                                color: #c3272b;
                            }
                            
                            .rest {
                                color: rgba(255, 193, 75, 1);
                            }
                        }
                    }
                    .not-current{
                        opacity: 0.2;
                    }
                }
            }
        }
        
        // 公共样式
        .fo-icon{
            color: #D9BC94;
        }
        .dao-icon{
            color: #000000;
        }
        .normal-icon{
            color: #c3272b;
        }
    }
    
    // 移动端日历头部样式
    .mobile-calendar-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
    }
    
    // 移动端当前信息样式
    .mobile-current-info {
        text-align: center;
        margin: 15px 0;
        padding: 15px;
        background-color: #f8f8f8;
        border-radius: 8px;
        
        .mobile-date {
            font-size: 20px;
            font-weight: bold;
            color: rgba(255, 193, 75, 1);
        }
        
        .mobile-lunar {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            margin: 5px 0 10px;
        }
        
        .van-button {
            width: 120px;
        }
    }
    
    // 移动端弹窗样式 (只影响日历组件内部的弹窗)
    .calendar-box.mobile .van-popup {
        .calendar-look-title {
            height: 150px;
            border-top: 10px solid rgba(255, 193, 75, 1);
            background-color: rgb(71, 69, 70);
            display: flex;
            align-items: center;
            justify-content: center;
            
            &-date {
                color: white;
                font-size: 36px;
                font-weight: bold;
            }
            
            &-lunar {
                width: 200px;
                height: 2px;
                position: relative;
                background-color: rgba(255, 193, 75, 1);
                margin-top: 20px;
                
                &-text {
                    position: absolute;
                    background-color: rgb(71, 69, 70);
                    padding-left: 20px;
                    color: rgba(255, 193, 75, 1);
                    font-size: 14px;
                    right: 0;
                    top: -11px;
                }
            }
        }
        
        .calendar-festival-add {
            width: calc(100% - 40px);
            box-sizing: border-box;
            padding: 10px 20px;
            position: absolute;
            bottom: 40px;
            left: 20px;
            border-radius: 10px;
            font-size: 16px;
            text-align: center;
            background-color: rgba(255, 193, 75, 1);
            color: white;
            cursor: default;
        }
    }
    
    // 确保移动端样式优先
    @media (max-width: 767px) {
        .calendar-box {
            flex-direction: column !important;
            padding: 10px !important;
            
            .calendar-info {
                width: 100% !important;
                text-align: center !important;
                margin-right: 0 !important;
                padding: 10px 0 !important;
            }
            
            .calendar-content {
                width: 100% !important;
            }
        }
    }
    
    // 移动端日历样式
    .mobile-calendar-day {
        padding: 0 10px;
        width: 100%;
        box-sizing: border-box;
    }
    
    // 移动端日历日列表
    .calendar-box.mobile .calendar-day {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        box-sizing: border-box;
        
        .calendar-day-list {
            width: 14.28%;
            margin-bottom: 10px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 60px;
            
            // 星期样式
            .calendar-day-list-week-small {
                width: 100%;
                text-align: center;
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 5px;
            }
            
            // 特殊日子标记图标 - 手机端隐藏
            .festival-icon {
                display: none;
            }
            
            // 手机端节日图标放在日期底层
            .mobile-festival-bg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 1;
                opacity: 0.7;
                display: flex;
                justify-content: center;
                align-items: center;
                
                .mobile-festival-icon {
                    position: absolute;
                    top: 50%;
                    
                    img {
                        width: 40px;
                        height: 40px;
                        object-fit: contain;
                    }
                }
            }
            
            &-info {
                width: 100%;
                padding: 5px;
                box-sizing: border-box;
                text-align: center;
                position: relative;
                z-index: 2;
                
                &-date {
                    font-size: 16px;
                    text-align: center;
                    font-weight: bold;
                    display: block;
                    padding: 2px 6px;
                    
                    .today {
                        color: #c3272b;
                    }
                    
                    .rest {
                        color: rgba(255, 193, 75, 1);
                    }
                }
                
                // 已选择日期样式
                &.selected {
                    .calendar-day-list-info-date {
                        background-color: rgba(255, 193, 75, 0.2);
                        border-radius: 12px;
                        color: rgba(255, 193, 75, 1);
                        
                        .today {
                            color: #c3272b;
                        }
                        
                        .rest {
                            color: rgba(255, 193, 75, 1);
                        }
                    }
                }
                
                &-lunar {
                    font-size: 10px;
                    text-align: center;
                    margin-top: 2px;
                    display: block;
                    background-color: white;
                    padding: 1px 4px;
                    border-radius: 8px;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                }
                
                // 手机端不显示节日名称
                &-festival {
                    display: none;
                }
            }
        }
    }
    
    // 电脑端保持原有样式
    .calendar-box:not(.mobile) {
        .calendar-day {
            .calendar-day-list {
                // 电脑端显示特殊日子标记图标
                .festival-icon {
                    display: block;
                }
                
                // 电脑端不显示底层节日图标
                .mobile-festival-bg {
                    display: none;
                }
                
                // 电脑端显示节日名称
                &-info {
                    &-festival {
                        display: block;
                    }
                }
            }
        }
    }
    
    // 移动端添加表单样式
    .mobile-add-form {
        padding: 15px;
    }
    
    // 移动端查看标题样式
    .mobile-look-title {
        height: 120px;
    }
    
    .calendar-detail{
        width:100%;
        position: relative;
    }
    
    .calendar-festival-add{
        width:calc(100% - 40px);
        box-sizing: border-box;
        padding: 10px 20px;
        position: absolute;
        bottom: 40px;
        left: 20px;
        border-radius: 10px;
        font-size: 16px;
        text-align:center;
        background-color:rgba(255, 193, 75, 1);
        color:white;
        cursor:default;
    }
    
    .calendar-look-title{
        border-top: 10px solid rgba(255, 193, 75, 1);
        width:100%;
        background-color:rgb(71,69,70);
        display:flex;
        align-items:center;
        justify-content:center;
        &-date{
            color:white;
            font-weight:bold;
        }
        &-lunar{
            height: 2px;
            position: relative;
            background-color:rgba(255, 193, 75, 1);
            margin-top: 20px;
            &-text{
                position:absolute;
                background-color:rgb(71,69,70);
                padding-left:20px;
                color: rgba(255, 193, 75, 1);
                right: 0;
                top: -11px;
            }
        }
    }
    
    .calendar-detail-festival{
        width:100%;
        box-sizing:border-box;
        &-list{
            width:100%;
            display:inline-flex;
            justify-contents:space-between;
            align-items:center;
            box-sizing:border-box;
            border-radius: 10px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            &-left{
                flex-shrink:0;
                box-sizing:border-box;
                padding: 5px;
                border:1px solid #D9BC94;
                border-radius:60px;
                margin-right: 10px;
            }
            &-content{
                width:100%;
                flex-shrink:1;
                font-weight:bold;
                letter-spacing:1px;
            }
            &-right{
                flex-shrink:0;
                .iconfont{
                    margin-left: 10px;
                }
            }
        }
    }
    
    .add-festival-form{
        width:100%;
        &-list{
            width:100%;
            margin-bottom:20px;
        }
        &-label{
            flex-shrink:0;
        }
        &-input{
            width:100%;
            flex-shrink:1;
            display: inline-flex;
            .form-span{
                margin-right:20px;
            }
        }
    }
</style>
<style>
    
    .el-card__body{
        width: 100%;
    }
</style>